// Django renders the {EVENT_NAME: eventKey} map from GameEvents (see
// itword/constants.py) into the page, and triggers them as htmx
// `HX-Trigger` events (see itword/views.py).
const eventsData = document.getElementById('game-events-data')

export const EVENTS = eventsData ? JSON.parse(eventsData.textContent) : {}

export const onGameEvent = (eventName, handler) => {
    if (!eventName) return
    document.addEventListener(eventName, handler)
}
